/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import clsx from 'clsx'
import { Link, useLocation } from 'react-router-dom'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { useLayout } from '../../core'
// import { Header } from './Header'
// import { Navbar } from './Navbar'
import { useDispatch } from 'react-redux'
import UserProfileMenu from '../../../../app/components/UserProfileMenu'
type HeaderWrapperProps = {
  onLogout: () => void; // onLogout is a function that returns void
};
export function HeaderWrapper({ onLogout }: HeaderWrapperProps) {
  const dispatch = useDispatch();
  const { config, classes } = useLayout();
  const location = useLocation();
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  if (!config.app?.header?.display) {
    return null;
  }

  // const handleLogout = () => {
  //   setTimeout(() => {
  //     dispatch({ type: 'USER_LOGOUT' });
  //   }, 1000);
  // };

  const breadcrumbMap2: { [key: string]: { hidden: boolean; text: string; link: string } } = {
    '/dashboard': { hidden: true, text: '', link: '' },
    '/analytic': { hidden: false, text: 'My PA', link: '/my-folder/analytic'  },
    '/payment-voucher': { hidden: false, text: 'My Payment Voucher', link: '/my-folder/payment-voucher'  },
    '/profile': { hidden: false, text: 'My Profile', link: '/my-folder/profile'  },
    '/cp58-listing': { hidden: false, text: 'My CP58 Listing', link: '/my-folder/cp58-listing'  },
    '/memo': { hidden: false, text: 'Memo Listing', link: '/memo' },
    '/company-letter': { hidden: false, text: 'Company Letter', link: '/company-letter' },
    '/secure-purchase-form': { hidden: false, text: 'Secure Purchase Form', link: '/purchase-form/secure-purchase-form' },
    '/employment-application/employment-listing': { hidden: false, text: 'Employment Application', link: '/employment-application/employment-listing' },
    '/employment-application/form/new': { hidden: false, text: 'Employment Application', link: '/employment-application/employment-listing' },
    '/employment-application/form/edit': { hidden: false, text: 'Employment Application', link: '/employment-application/employment-listing' },
    '/employment-application/attachment-listing': { hidden: false, text: 'Employment Application Attachment', link: '/employment-application/attachment-listing' },
    '/employment-application/upload/attachment': { hidden: false, text: 'Employment Application Attachment', link: '/employment-application/attachment-listing' },
    '/purchase-cum-receipt-form': { hidden: false, text: 'Purchase Cum Receipt Form', link: '/purchase-form/purchase-cum-receipt-form'  },
    '/secure-rent-form': { hidden: false, text: 'Secure Rent Form', link: '/rent-form/secure-rent-form' },
    '/rent-cum-receipt-form': { hidden: false, text: 'Rent Cum Receipt Form', link: '/rent-form/rent-cum-receipt-form' },
    '/developer-sale-form': { hidden: false, text: 'Developer Sale Form', link: '/developer-sale-form' },
    '/claim-submission-form': { hidden: false, text: 'Claim Submission Form', link: '/claim-submission-form' },
    '/official-receipt/request-listing': { hidden: false, text: 'Official Receipt Request', link: '/official-receipt/request-listing' },
    '/official-receipt/request-history': { hidden: false, text: 'Official Receipt Request History', link: '/official-receipt/request-history' },
    '/official-receipt/listing': { hidden: false, text: 'Official Receipt', link: '/official-receipt/listing' },
    '/tax-invoice/request-listing': { hidden: false, text: 'Tax Invoice Request', link: '/tax-invoice/request-listing' },
    '/tax-invoice/request-history': { hidden: false, text: 'Tax Invoice Request History', link: '/tax-invoice/request-history' },
    '/tax-invoice/listing': { hidden: false, text: 'Tax Invoice', link: '/tax-invoice/listing' },
    '/my-store/order-listing': { hidden: false, text: 'Store Order Listing', link: '/my-store/order-listing' },
    '/settings/change-password': { hidden: false, text: 'Change Password', link: '/settings/change-password' },
  };
  
  const breadcrumbLvl2 = Object.keys(breadcrumbMap2).reduce((acc, key) => {
    return location.pathname.includes(key) ? breadcrumbMap2[key] : acc;
  }, { hidden: true, text: '',  link: ''});
  
  const breadcrumbMap3: { [key: string]: { hidden: boolean; text: string } } = {
    '/employment-application/form/new': { hidden: false, text: 'Add Employment Application' },
    '/employment-application/form/edit': { hidden: false, text: 'Edit Employment Application' },
    '/employment-application/upload/attachment': { hidden: false, text: 'Upload PaySlip & NRIC' },
    '/secure-purchase-form/new': { hidden: false, text: 'Add Secure Purchase Form' },
    '/secure-purchase-form/edit': { hidden: false, text: 'Edit Secure Purchase Form' },
    '/secure-rent-form/new': { hidden: false, text: 'Add Secure Rent Form' },
    '/secure-rent-form/edit': { hidden: false, text: 'Edit Secure Rent Form' },
    '/developer-sale-form/new': { hidden: false, text: 'Add Developer Sale Form' },
    '/developer-sale-form/edit': { hidden: false, text: 'Edit Developer Sale Form' },
    '/developer-sale-form/upload/attachment': { hidden: false, text: 'Developer Sale Attachment' },
    '/claim-submission-form/view': { hidden: false, text: 'View Claim Submission Form' },
    '/claim-submission-form/new': { hidden: false, text: 'View Claim Submission Form' },
  };
  
  const breadcrumbLvl3 = Object.keys(breadcrumbMap3).reduce((acc, key) => {
    return location.pathname.includes(key) ? breadcrumbMap3[key] : acc;
  }, { hidden: true, text: '' });

  const toggleMenuVisibility = () => {
    setIsMenuVisible(!isMenuVisible);
  };
  return (
    // <div id='kt_app_header' className='app-header'>
    <div id='kt_app_header' className='custom-app-header'>
      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container flex-lg-grow-1',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {config.app.sidebar?.display && (
          <>
            <div
              className='d-flex align-items-center d-lg-none ms-n2 me-2'
              title='Show sidebar menu'
            >
              <div
                className='btn btn-icon btn-active-color-primary w-35px h-35px'
                id='kt_app_sidebar_mobile_toggle'
              >
                {/* <KTIcon iconName='abstract-14' className=' fs-1' /> */}
                <KTIcon iconName='text-align-left' className=' fs-1' />
              </div>
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                <Link to='/dashboard' className='d-lg-none'>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/sidebar/trr_logo.svg')}
                    className='h-30px'
                  />
                </Link>
              </div>
            </div>
          </>
        )}
        <div className='breadCrumb'>
          <div id='breadCrumbDiv1'>
            <img src={toAbsoluteUrl('/media/sidebar/ki-home-2.svg')} />
            <Link to='/dashboard'>
              Dashboard
            </Link>
          </div>
          {!breadcrumbLvl2.hidden && (
            <div id='breadCrumbDiv2'>
              <img src={toAbsoluteUrl('/media/sidebar/icon-bullet.svg')} />
              {!breadcrumbLvl3.hidden ? (
                <Link to={breadcrumbLvl2.link}>
                {breadcrumbLvl2.text}
                </Link>
              ) : (
                breadcrumbLvl2.text
              )}
            </div>
          )}
          {!breadcrumbLvl3.hidden && (
            <div id='breadCrumbDiv3'>
              <img src={toAbsoluteUrl('/media/sidebar/icon-bullet.svg')} />
              {breadcrumbLvl3.text}
            </div>
          )}
        </div>
        <div className='actionButton d-none'>
          <img src={toAbsoluteUrl('/media/sidebar/ki-messages.svg')} />
        </div>
        <div className='profileIcon'>
          <div className={`cursor-pointer ${isMenuVisible ? 'outline-green2' : ''}`} onClick={toggleMenuVisibility}>
            <img src={toAbsoluteUrl('/media/sidebar/ki-user-circle.svg')} />
          </div>
          {isMenuVisible && (
            <div className='menuWrapper'>
              <div className='profileHeader'>
                <div className='photo'>
                  <img src={toAbsoluteUrl('/media/sidebar/ki-user-circle.svg')} />
                </div>
                <UserProfileMenu/>
              </div>
              <Link className='menu-link without-sub' to='my-folder/profile' onClick={toggleMenuVisibility}>
                <div className='d-flex profileItem'>
                  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5 4.5H11.5C7.63401 4.5 4.5 7.63401 4.5 11.5V24.5C4.5 28.366 7.63401 31.5 11.5 31.5H24.5C28.366 31.5 31.5 28.366 31.5 24.5V11.5C31.5 7.63401 28.366 4.5 24.5 4.5ZM11.5 1.5C5.97715 1.5 1.5 5.97715 1.5 11.5V24.5C1.5 30.0228 5.97715 34.5 11.5 34.5H24.5C30.0228 34.5 34.5 30.0228 34.5 24.5V11.5C34.5 5.97715 30.0228 1.5 24.5 1.5H11.5Z" fill="#A7A9AC" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.51233 33.1131C9.46549 33.1875 9.30382 33.4442 9.04033 33.6432L7.23199 31.2495C7.10359 31.3465 7.0205 31.4478 6.9864 31.4944C7.00283 31.4677 7.03368 31.4141 7.08708 31.3152C7.1179 31.2581 7.15744 31.1834 7.20325 31.0969C7.30176 30.9107 7.42927 30.6698 7.56146 30.4314C7.97231 29.6905 8.57253 28.702 9.42298 27.7148C11.1454 25.7155 13.9026 23.7241 18.1188 23.7241C24.9216 23.7241 28.4606 29.2678 29.3947 31.9536L26.5612 32.9391C25.8207 30.8101 23.0714 26.7241 18.1188 26.7241C14.9878 26.7241 13.0032 28.1554 11.6959 29.6729C11.0314 30.4442 10.5447 31.2377 10.1851 31.8863C10.0639 32.1047 9.97042 32.2817 9.88164 32.4497C9.82997 32.5475 9.77991 32.6423 9.72695 32.7404C9.66448 32.8561 9.59165 32.9878 9.51713 33.1055C9.51569 33.1078 9.51409 33.1103 9.51233 33.1131ZM6.98242 31.5008C6.9628 31.5317 6.96445 31.5244 6.9864 31.4944C6.98497 31.4967 6.98364 31.4988 6.98242 31.5008Z" fill="#A7A9AC" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0011 19.3982C20.0382 19.3982 21.6897 17.7467 21.6897 15.7096C21.6897 13.6724 20.0382 12.021 18.0011 12.021C15.9639 12.021 14.3125 13.6724 14.3125 15.7096C14.3125 17.7467 15.9639 19.3982 18.0011 19.3982ZM18.0011 22.3982C21.6951 22.3982 24.6897 19.4036 24.6897 15.7096C24.6897 12.0156 21.6951 9.021 18.0011 9.021C14.3071 9.021 11.3125 12.0156 11.3125 15.7096C11.3125 19.4036 14.3071 22.3982 18.0011 22.3982Z" fill="#A7A9AC" />
                  </svg>
                  My Profile
                </div>
              </Link>
              <Link className='menu-link without-sub' to='settings/change-password' onClick={toggleMenuVisibility}>
                <div className='d-flex profileItem' onClick={toggleMenuVisibility}>
                  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 4.5H24.5C28.366 4.5 31.5 7.63401 31.5 11.5V24.5C31.5 28.366 28.366 31.5 24.5 31.5H11.5C7.63401 31.5 4.5 28.366 4.5 24.5V11.5C4.5 7.63401 7.63401 4.5 11.5 4.5ZM1.5 11.5C1.5 5.97715 5.97715 1.5 11.5 1.5H24.5C30.0228 1.5 34.5 5.97715 34.5 11.5V24.5C34.5 30.0228 30.0228 34.5 24.5 34.5H11.5C5.97715 34.5 1.5 30.0228 1.5 24.5V11.5ZM24.7262 11.5922C22.424 9.29001 18.5313 9.10297 16.2991 11.3352C15.4373 12.197 14.9947 13.334 14.785 14.5696C14.5897 15.7207 14.6129 16.8377 14.6323 17.772L14.637 18.0073L14.6493 18.6533L10.0012 23.218L10.1504 25.8754L12.1581 26.1913L13.3287 25.3423L11.5251 23.3692L13.616 21.4578L15.1638 23.1509L17.212 21.1551L17.7764 21.1258C18.0893 21.1096 18.4113 21.0994 18.7416 21.0889L18.7419 21.0889L18.7422 21.0889H18.7422C19.6349 21.0607 20.5875 21.0305 21.582 20.8741C22.9265 20.6625 24.0177 20.2563 24.7262 19.5478C25.4328 18.8412 26.0431 17.4187 26.1217 15.7718C26.199 14.1522 25.7486 12.6146 24.7262 11.5922ZM15.6271 23.6841L13.5604 25.5733L15.1321 27.7403L12.9161 29.3475L7.29097 28.4623L6.92969 22.0296L11.6243 17.4192C11.6091 16.5235 11.6153 15.3171 11.8273 14.0677C12.0982 12.4715 12.724 10.6676 14.1778 9.21391C17.7343 5.65738 23.5325 6.15588 26.8475 9.47091C28.6338 11.2572 29.2232 13.7182 29.1183 15.9149C29.0147 18.0845 28.2206 20.2961 26.8475 21.6691C25.4763 23.0403 23.6339 23.5882 22.0482 23.8376C20.8495 24.0262 19.6067 24.065 18.6831 24.0939L18.4884 24.1001L17.2286 25.3277L15.6271 23.6841ZM20.4833 16.4499C20.9702 16.4499 21.365 16.0552 21.365 15.5682C21.365 15.0813 20.9702 14.6865 20.4833 14.6865C19.9963 14.6865 19.6016 15.0813 19.6016 15.5682C19.6016 16.0552 19.9963 16.4499 20.4833 16.4499ZM20.4833 19.4499C22.6271 19.4499 24.365 17.712 24.365 15.5682C24.365 13.4244 22.6271 11.6865 20.4833 11.6865C18.3395 11.6865 16.6016 13.4244 16.6016 15.5682C16.6016 17.712 18.3395 19.4499 20.4833 19.4499Z" fill="#A7A9AC" />
                  </svg>
                  Change Password
                </div>
              </Link>
              <div className='d-flex profileItem cursor-pointer' onClick={onLogout}>
                <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.04549 4.2779C6.20486 2.68812 7.97102 1.80225 10.188 1.80225L19.2457 1.8023C21.6671 1.8023 23.3654 3.19536 24.391 4.75035C25.395 6.27266 25.8785 8.11179 25.8785 9.50861C25.8785 10.337 25.207 11.0086 24.3785 11.0086C23.5501 11.0086 22.8785 10.337 22.8785 9.50861C22.8785 8.69405 22.5646 7.43003 21.8866 6.40203C21.2302 5.40671 20.3621 4.8023 19.2457 4.8023L10.188 4.80225C8.85127 4.80225 8.0195 5.29125 7.4694 6.04558C6.86919 6.8686 6.49219 8.17071 6.49219 9.92892V25.5559C6.49219 27.1388 7.21608 28.5536 8.28674 29.5951C9.38156 30.66 10.6957 31.1981 11.6792 31.1981H18.4787C19.9843 31.1981 21.0403 30.5294 21.7607 29.593C22.5152 28.6124 22.8785 27.3547 22.8785 26.3627C22.8785 25.5343 23.5501 24.8627 24.3785 24.8627C25.207 24.8627 25.8785 25.5343 25.8785 26.3627C25.8785 27.9769 25.3199 29.8868 24.1384 31.4224C22.9229 33.0022 21.0289 34.1981 18.4787 34.1981H11.6792C9.74315 34.1981 7.71376 33.2229 6.19497 31.7455C4.65202 30.2447 3.49219 28.0885 3.49219 25.5559V9.92892C3.49219 7.8102 3.93622 5.79898 5.04549 4.2779ZM25.7683 12.3277C26.3541 11.7419 27.3038 11.7419 27.8896 12.3277L32.0647 16.5028C32.6505 17.0886 32.6505 18.0383 32.0647 18.6241L27.8896 22.7992C27.3038 23.385 26.3541 23.385 25.7683 22.7992C25.1825 22.2135 25.1825 21.2637 25.7683 20.6779L27.3828 19.0635H13.886C13.0576 19.0635 12.386 18.3919 12.386 17.5635C12.386 16.735 13.0576 16.0635 13.886 16.0635H27.3828L25.7683 14.449C25.1825 13.8632 25.1825 12.9134 25.7683 12.3277Z" fill="#A7A9AC" />
                </svg>
                Sign Out
              </div>
            </div>
          )}
        </div>
        {/* <div className='mobile-logout-btn actionButton d-flex align-items-center' onClick={handleLogout}>
          <svg
            className='dashboard-logout-icon'
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='19'
            viewBox='0 0 22.414 20'
          >
            <path
              id='Path_9214'
              data-name='Path 9214'
              d='M626,684l4,4m0,0-4,4m4-4H617m6-7.8a8.382,8.382,0,0,0-4.333-1.2,9.006,9.006,0,0,0,0,18A8.382,8.382,0,0,0,623,695.8'
              transform='translate(-609 -678)'
              fill='none'
              stroke='#a7a9ac'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1.5'
            /> 
          </svg>
        </div> */}

        {/* {!(config.layoutType === 'dark-sidebar' || config.layoutType === 'light-sidebar') && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link to='/dashboard'>
              {config.layoutType !== 'dark-header' ? (
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logos/default.svg')}
                  className='h-20px h-lg-30px app-sidebar-logo-default'
                />
              ) : (
                <>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-dark.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                  />
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-small-dark.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show'
                  />
                </>
              )}
            </Link>
          </div>
        )} */}
        {/* <div
          id='kt_app_header_wrapper'
          className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
        >
          {config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className='app-header-menu app-header-mobile-drawer align-items-stretch'
                data-kt-drawer='true'
                data-kt-drawer-name='app-header-menu'
                data-kt-drawer-activate='{default: true, lg: false}'
                data-kt-drawer-overlay='true'
                data-kt-drawer-width='225px'
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#kt_app_header_menu_toggle'
                data-kt-swapper='true'
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
              >
                <Header />
              </div>
            )}
          <Navbar />
        </div> */}
      </div>
    </div>
  );
}
